import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'app/core/core.module';
import { SiteListComponent } from './site-list.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule
  ],
  exports: [SiteListComponent],
  declarations: [SiteListComponent],
})
export class SiteListModule { }
